// extracted by mini-css-extract-plugin
export var content = "_pn-1";
export var fullScreen = "_pn-0";